var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.5C8.85786 5.5 5.5 8.85786 5.5 13C5.5 17.1421 8.85786 20.5 13 20.5C15.0368 20.5 16.8839 19.6881 18.2354 18.3703C18.253 18.3443 18.2734 18.3195 18.2964 18.2964C18.3195 18.2734 18.3443 18.253 18.3703 18.2354C19.6881 16.8839 20.5 15.0368 20.5 13C20.5 8.85786 17.1421 5.5 13 5.5ZM19.3536 18.6465C20.6889 17.1451 21.5 15.1673 21.5 13C21.5 8.30558 17.6944 4.5 13 4.5C8.30558 4.5 4.5 8.30558 4.5 13C4.5 17.6944 8.30558 21.5 13 21.5C15.1673 21.5 17.1451 20.6889 18.6465 19.3536L22.6464 23.3536C22.8417 23.5488 23.1583 23.5488 23.3536 23.3536C23.5488 23.1583 23.5488 22.8417 23.3536 22.6464L19.3536 18.6465Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.5147f1fe.svg";
export { ForwardRef as ReactComponent };